import { set } from 'src/utils/vuex'

export const SET_BATCH = set('batch')
export const SET_LOADING = set('loading')
